import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { pagedQuestionnairesSchema } from '../schemas/questionnaireSchemas';
import { questionnaireKeys } from './questionnaireKeys';

interface ListParams {
  page: number;
  pageSize: number;
  search?: string;
  status?: string;
}

export function useListQuestionnaires({ page, pageSize, search, status }: ListParams) {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: questionnaireKeys.list({ page, pageSize, search, status }),
    queryFn: async ({ signal }) => {
      const searchParams: Record<string, string | number> = { page, pageSize };
      if (search) searchParams.search = search;
      if (status) searchParams.status = status;

      const raw = await apiClient
        .get(`api/v1/t/${tenantId}/questionnaires`, { searchParams, signal })
        .json();

      return pagedQuestionnairesSchema.parse(raw);
    },
    enabled: !!tenantId,
  });
}
